"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var UNITS = {
  mins: 'mins',
  minutes: 'mins',
  hrs: 'hrs',
  hours: 'hrs',
  mbs: 'MBs',
  mb: 'MBs',
  gbs: 'GBs',
  gb: 'GBs',
  tbs: 'TBs',
  tb: 'TBs',
  sms: 'SMS'
};
var _default = UNITS;
exports.default = _default;